module.exports = __webpack_public_path__ + "static/img/1.2edcc6f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/sp/1.png
// module id = MS4W
// module chunks = 0